


export type TimeEntryTypeCategory = 'Unknown' | 'Salary';

export const TimeEntryTypeCategory = {
    Unknown: 'Unknown' as TimeEntryTypeCategory,
    Salary: 'Salary' as TimeEntryTypeCategory
};

